/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { createCluDeployModelHandlerGroup } from 'src/clu/modules/handlers/cluDeployModelHandlerGroup';
import { createCluEntityHandlerGroup } from 'src/clu/modules/handlers/entities/cluEntityHandlerGroup';
import { createCluIntentHandlerGroup } from 'src/clu/modules/handlers/intents/cluIntentHandlerGroup';
import { createCluTestModelHandlerGroup } from 'src/clu/modules/handlers/testModel/cluTestModelHandlerGroup';
import { createCluTrainedModelHandlerGroup } from 'src/clu/modules/handlers/trainedModels/cluTrainedModelHandlerGroup';
import { createCluUtteranceHandlerGroup } from 'src/clu/modules/handlers/utterances/cluUtteranceHandlerGroup';
import { useGlobalState } from 'src/core/hooks/useGlobalState';
import { useInstallHandlerGroup } from 'src/core/hooks/useInstallHandlerGroup';

export const useCluStartupConfigs = () => {
    const { dispatcher } = useGlobalState();

    useInstallHandlerGroup(
        dispatcher,
        createCluIntentHandlerGroup,
        createCluEntityHandlerGroup,
        createCluUtteranceHandlerGroup,
        createCluTestModelHandlerGroup,
        createCluDeployModelHandlerGroup,
        createCluTrainedModelHandlerGroup
    );
};
